(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      // Use closest to ensure we target THIS section, avoiding conflicts with announcement bars etc.
      this.header = this.closest('.shopify-section') || document.querySelector('.section-header');
      if (!this.header) return;
      this.headerElement = this.querySelector('.header');
      this.mobileSearchButton = this.querySelector('.header__icon--search-mobile');
      this.mobileSearchInput = this.querySelector('.header__search-bar-input');
      this.mobileMediaQuery = window.matchMedia('(max-width: 989px)');
      this.mobileMenuDetails = this.querySelector('header-drawer details');

      this.stickyType = this.getAttribute('data-sticky-type');
      this.headerIsAlwaysSticky =
        this.stickyType === 'always' ||
        this.stickyType === 'reduce-logo-size';

      // Scroll inicial
      this.lastKnownScrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      
      // Placeholder para evitar saltos al poner position:fixed
      this.headerPlaceholder = document.querySelector('.header-placeholder');
      if (!this.headerPlaceholder) {
        this.headerPlaceholder = document.createElement('div');
        this.headerPlaceholder.className = 'header-placeholder';
        // Prevent browser scroll anchoring interference
        this.headerPlaceholder.style.overflowAnchor = 'none';
        this.header.parentElement.insertBefore(this.headerPlaceholder, this.header);
      }

      // Setear altura para CSS + ResizeObserver para cambios dinÃ¡micos (imÃ¡genes, fuentes)
      this.setHeaderHeight();
      
      this.resizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.resizeObserver.observe(this.header);

      window
        .matchMedia('(max-width: 990px)')
        .addEventListener('change', () => this.setHeaderHeight());

      if (this.mobileSearchButton && this.mobileSearchInput) {
        this.onMobileSearchToggle = this.toggleMobileSearch.bind(this);
        this.onMobileSearchKeydown = this.handleMobileSearchKeydown.bind(this);
        this.onMobileBreakpointChange = this.handleMobileBreakpointChange.bind(this);
        this.mobileSearchButton.addEventListener('click', this.onMobileSearchToggle);
        document.addEventListener('keydown', this.onMobileSearchKeydown);
        this.mobileMediaQuery.addEventListener('change', this.onMobileBreakpointChange);
      }

      if (this.mobileMenuDetails) {
        this.onMobileMenuToggle = this.handleMobileMenuToggle.bind(this);
        this.mobileMenuDetails.addEventListener('toggle', this.onMobileMenuToggle);
      }

      // Always / reduce-logo-size â†’ siempre visible
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        this.updatePlaceholder(true);
        return;
      }

      // Solo on-scroll-up
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    }
      


    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.mobileSearchButton && this.onMobileSearchToggle) {
        this.mobileSearchButton.removeEventListener('click', this.onMobileSearchToggle);
      }
      if (this.onMobileSearchKeydown) {
        document.removeEventListener('keydown', this.onMobileSearchKeydown);
      }
      if (this.mobileMediaQuery && this.onMobileBreakpointChange) {
        this.mobileMediaQuery.removeEventListener('change', this.onMobileBreakpointChange);
      }
      if (this.mobileMenuDetails && this.onMobileMenuToggle) {
        this.mobileMenuDetails.removeEventListener('toggle', this.onMobileMenuToggle);
      }
    }

    toggleMobileSearch() {
      if (!this.mobileMediaQuery.matches || !this.headerElement || !this.mobileSearchButton) return;

      const willOpen = !this.headerElement.classList.contains('header--mobile-search-open');
      if (willOpen && this.mobileMenuDetails?.open) {
        this.mobileMenuDetails.removeAttribute('open');
      }
      this.headerElement.classList.toggle('header--mobile-search-open', willOpen);
      this.mobileSearchButton.setAttribute('aria-expanded', willOpen ? 'true' : 'false');

      if (willOpen && this.mobileSearchInput) {
        requestAnimationFrame(() => {
          this.mobileSearchInput.focus();
          this.mobileSearchInput.select();
        });
      }
    }

    handleMobileSearchKeydown(event) {
      if (event.key !== 'Escape' || !this.headerElement || !this.mobileSearchButton) return;
      if (!this.headerElement.classList.contains('header--mobile-search-open')) return;

      this.headerElement.classList.remove('header--mobile-search-open');
      this.mobileSearchButton.setAttribute('aria-expanded', 'false');
      this.mobileSearchButton.focus();
    }

    handleMobileBreakpointChange(event) {
      if (event.matches || !this.headerElement || !this.mobileSearchButton) return;
      this.headerElement.classList.remove('header--mobile-search-open');
      this.mobileSearchButton.setAttribute('aria-expanded', 'false');
    }

    handleMobileMenuToggle() {
      if (!this.mobileMenuDetails?.open || !this.headerElement || !this.mobileSearchButton) return;
      this.headerElement.classList.remove('header--mobile-search-open');
      this.mobileSearchButton.setAttribute('aria-expanded', 'false');
    }

    setHeaderHeight() {
      if (!this.header) return;
      const styles = window.getComputedStyle(this.header);
      // Bug fix: incluir mÃ¡rgenes en la altura total para que el placeholder sea exacto
      const totalHeight = this.header.offsetHeight + parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
      
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
      
      // Si el header ya es sticky, actualizamos el placeholder en vivo
      if (this.header.classList.contains('shopify-section-header-sticky')) {
          this.updatePlaceholder(true);
      }
    }
    
    updatePlaceholder(isSticky) {
      if (!this.headerPlaceholder) return;
      
      // Auto-correction: If component layout says it's sticky, force the placeholder to exist.
      // This prevents the '0px' bug if logic flows partially.
      if (this.header.classList.contains('shopify-section-header-sticky')) {
          isSticky = true;
      }

      if (isSticky) {
        const styles = window.getComputedStyle(this.header);
        const h = this.header.offsetHeight;
        const mt = parseFloat(styles.marginTop) || 0;
        const mb = parseFloat(styles.marginBottom) || 0;
        const totalHeight = h + mt + mb;
        
        // FORCE the height with specific style properties to override any external CSS
        this.headerPlaceholder.style.setProperty('height', `${totalHeight}px`, 'important');
        this.headerPlaceholder.style.setProperty('min-height', `${totalHeight}px`, 'important');
        this.headerPlaceholder.style.display = 'block';
      } else {
        this.headerPlaceholder.style.height = '0px';
        this.headerPlaceholder.style.minHeight = '0px';
      }
    }

    onScroll() {

      
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      // Calculate TOTAL height for accurate threshold (Offset + Margins)
      const styles = window.getComputedStyle(this.header);
      const totalHeaderHeight = this.header.offsetHeight + parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
      const buffer = 15;

      // Arriba del todo â†’ reset total
      if (scrollTop <= 0) {
        this.header.classList.remove(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky',
          'animate',
          'scrolled-past-header'
        );
        this.header.style.transform = ''; // Clear inline styles
        this.updatePlaceholder(false);
        this.lastKnownScrollTop = scrollTop;
        return;
      }

      // Check delta
      if (Math.abs(this.lastKnownScrollTop - scrollTop) <= 10) return;

      const scrollingDown = scrollTop > this.lastKnownScrollTop;
      const pastHeader = scrollTop > (totalHeaderHeight + buffer);
      const isSticky = this.header.classList.contains('shopify-section-header-sticky');

      if (!pastHeader) {
        // Si estamos bajando, o si NO es sticky (estado natural arriba), limpiamos.
        // PERO si estamos subiendo y YA es sticky, queremos que siga fijo hasta llegar a 0 para evitar el salto.
        // Logic fix: Only reset if NOT sticky. If sticky, hold it until scrollTop 0.
        if (!isSticky) {
          this.header.classList.remove(
            'shopify-section-header-hidden',
            'shopify-section-header-sticky',
            'animate',
            'scrolled-past-header'
          );
          this.header.style.transform = ''; // Clear inline styles
          this.updatePlaceholder(false);
          this.lastKnownScrollTop = scrollTop;
          return;
        }
        // Si no entramos al if, dejamos que el cÃ³digo siga para mantenerlo sticky (docking suave)
      }

      // Ya pasaste el header (o lo estÃ¡s 'dockeando')
      this.header.classList.add('scrolled-past-header');

      if (scrollingDown && pastHeader) {
        // Optimization: Activate placeholder FIRST to reserve space before lifting the header.
        this.updatePlaceholder(true);
        
        // Force reflow
        void this.header.offsetWidth;
        
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.add('shopify-section-header-hidden');
        this.header.classList.remove('animate');
        
        // Force hide with inline style to override the "nuclear" show style
        this.header.style.transform = 'translateY(-100%)';
      } else {
        // MOSTRAR al subir
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
        
        // Force aggressive visibility SYNCHRONOUSLY
        this.header.style.transform = 'translateY(0)';
        this.header.style.top = '0px';
        this.header.style.zIndex = '100000';
        this.header.style.opacity = '1';
        this.header.style.visibility = 'visible';
        this.header.style.display = 'block';

        this.updatePlaceholder(true);
      }

      this.lastKnownScrollTop = scrollTop;
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
